module.exports = __webpack_public_path__ + "static/media/visitapp-logo.c7f696f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visitapp-logo.png
// module id = 936
// module chunks = 0